import {growlStore, VhsLabelPrintDialogStore} from "../../../store";
import {observer} from "mobx-react";
import {FieldAutoComplete, ModalDialog} from "../../ui";
import {vhsPrinterStore} from "../../../store/vhs/VhsPrinterStore";
import {convertDocumentType} from "../../../api";

export type VhsLabelPrintDialogProps = {
    store: VhsLabelPrintDialogStore
}




const VhsLabelPrintDialog = observer(function VhsLabelPrintDialog({
                                                            store
                                                        }: VhsLabelPrintDialogProps) {

    return <>
        <ModalDialog
            titleCloseable={true}
            store={store}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {

                        store.dialogOpen = false
                    },
                    className: 'is-rounded is-small'
                },
                {
                    label: "Label drucken",
                    execute: async function () {
                        store.executing = true
                        const success = await store.triggerLabelPrint()
                        if (success) {
                            growlStore.add({
                                autoclose: true,
                                message: 'Labeldruck initiiert'
                            })
                        }
                        store.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                }
            ]}
            title={`Label Nachdruck für ${convertDocumentType(store.document?.type)}`}
        >
            <div>
                <strong>Dokumenten-Id: </strong>{store.document?.documentId}
            </div>
            <div>
                <strong>Lagerort: </strong>{store.document?.location}
            </div>
            <div style={{paddingTop: '1em'}}>
                <FieldAutoComplete
                    label={"Labeldrucker"}
                    help={"Bitte wähle den zu verwendenden Drucker"}
                    required={true}
                    itemRenderer={c => c.label}
                    options={vhsPrinterStore.options}
                    search={async (v) => {
                        await vhsPrinterStore.find(v)
                        return vhsPrinterStore.options
                    }}
                    value={store.printer}
                    onChange={v => {
                        store.printer = v
                    }}
                />
            </div>
        </ModalDialog>
    </>
})

export {
    VhsLabelPrintDialog
}
